import { render, staticRenderFns } from "./FullRow.vue?vue&type=template&id=5623e198&"
import script from "./FullRow.vue?vue&type=script&lang=js&"
export * from "./FullRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports